import { gql } from "@/services/httpAdapter.ts";

import { TitlingFragment } from "./fragments.ts";

export const onUpdateTitlings = gql`
	subscription onUpdateTitlings($commissionCycleId: String!, $payPeriodId: String!) {
		onUpdateTitlings(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			titlings {
				...Titling
			}
		}
	}
	${TitlingFragment}
`;
